import { API_URL, conf, tenantConfig } from 'config';
import AuthService from 'services/AuthService';
import { HttpService } from 'services/HttpService';
import ClaimType from 'store/enums/ClaimType';
import ClaimUploadType from 'store/enums/ClaimUploadType';
import { Claim } from 'store/types/Claim';
import { httpRequestWrapper } from 'util/Request';

class ClaimsService {
  public static getClaims(companyId: string): Promise<Claim[]> {
    return new Promise<Claim[]>((resolve: (data: Claim[]) => void, reject: (error: string) => void) => {
      httpRequestWrapper<Claim[]>(
        HttpService.get(`${API_URL}/claims/${companyId}`, {
          headers: {
            TenantId: tenantConfig.id,
            authorization: AuthService.getBearerToken(),
          },
        }),
        resolve,
        reject
      );
    });
  }

  public static disputeClaim(companyId: string, claimId: string): Promise<Claim[]> {
    return new Promise<Claim[]>((resolve: (data: Claim[]) => void, reject: (error: string) => void) => {
      httpRequestWrapper<Claim[]>(
        HttpService.post(`${API_URL}/claims/${companyId}/dispute`, {
          headers: {
            TenantId: tenantConfig.id,
            authorization: AuthService.getBearerToken(),
          },
          data: {
            claimId,
          },
        }),
        resolve,
        reject
      );
    });
  }

  public static closeClaim(companyId: string, claimId: string): Promise<Claim[]> {
    return new Promise<Claim[]>((resolve: (data: Claim[]) => void, reject: (error: string) => void) => {
      httpRequestWrapper<Claim[]>(
        HttpService.post(`${API_URL}/claims/${companyId}/close`, {
          headers: {
            TenantId: tenantConfig.id,
            authorization: AuthService.getBearerToken(),
          },
          data: {
            claimId,
          },
        }),
        resolve,
        reject
      );
    });
  }

  public static uploadFile(
    claimId: string,
    companyId: string,
    claimType: ClaimType,
    uploadType: ClaimUploadType,
    description: string,
    file: File
  ): Promise<string> {
    const data = new FormData();
    data.append('claimId', claimId);
    data.append('companyId', companyId);
    data.append('claimType', claimType);
    data.append('uploadType', uploadType);
    data.append('description', description);
    data.append('file', file);

    return new Promise<string>((resolve: (data: string) => void, reject: (error: string) => void) => {
      httpRequestWrapper<string>(
        HttpService.post(`${API_URL}/claims/file`, {
          data,
          headers: {
            TenantId: tenantConfig.id,
            authorization: AuthService.getBearerToken(),
          },
        }),
        resolve,
        reject
      );
    });
  }

  public static getClaimJudgeFile(claimId: string, companyId: string, filename: string): Promise<null> {
    return new Promise<null>((resolve: (data: null) => void, reject: (error: string) => void) => {
      httpRequestWrapper<null>(
        HttpService.getFileDownload(`${API_URL}/claims/${companyId}/judge-file/${claimId}`, {
          headers: {
            TenantId: tenantConfig.id,
            authorization: AuthService.getBearerToken(),
            [conf.filenameHeader]: filename,
          },
        }),
        resolve,
        reject
      );
    });
  }
}

export default ClaimsService;
